import { api } from './http';

export const REPORT_PAGE_SIZE = 50;

function reportQuery(filters, discriminator, size = REPORT_PAGE_SIZE) {
  const params = new URLSearchParams({
    from: filters.from,
    to: filters.to,
  });
  if (discriminator) params.set(discriminator, filters[discriminator] || 'ALL');
  params.set('page', String(filters.page || 0));
  params.set('size', String(size));
  if (filters.forkliftId) params.set('forkliftId', String(filters.forkliftId));
  return params.toString();
}

export function getServiceHistory(filters, size) {
  return api.get(`/api/reports/service-history?${reportQuery(filters, 'type', size)}`);
}

export function getRecordedFailures(filters, size) {
  return api.get(`/api/reports/failures?${reportQuery(filters, 'source', size)}`);
}

export function getAvailability(filters, size) {
  return api.get(`/api/reports/availability?${reportQuery(filters, null, size)}`);
}
